module.exports = {
  PRIVILEGE: {
    TYPE: {
      IMMEDIATE: "IMMEDIATE",
      REGISTER: "REGISTER"
    },
    USAGE_TYPE: {
      ACTIVITY: "ACTIVITY",
      REDEEM: "REDEEM"
    }
  },
  USER_PRIVILEGE_REGISTER: {
    TYPE: {
      UNPICK: "UNPICK",
      PICKED: "PICKED",
      RESERVE: "RESERVED"
    }
  },
  SIDE_NAV_BAR_FEATURE: {
    NEWS: "News",
    ACTIVITY: "Activity",
    PRIVILEGE: "Privilege",
    HOME_CARE: "Home care",
    STAFF_MANAGEMENT: "Staff Management",
    GREETING: "Greeting",
    REPORT: "Report",
    NOTICE: "Notice",
    POPUP_BANNER: "Popup Banner",
    REFINANCE: "Refinance",
    INSURANCE: "Insurance",
    SUBSCRIPTION_REPORT: "Subscription Report",
    HA_INFO: "HA.HAInfo",
    HA_LOG: "HA.HALog",
    HA_STAFF_ACTIVITY_LOG: "HA.StaffActivityLog",
    HA_FAQ: "HA.FAQ",
    SELL_AND_RENT: "Sell And Rent",
    MONITORING: "Monitoring",
    FINANCIAL_INSTITUTION_MANAGEMENT: "Financial Institution Management",
    RUEJAI_CLUB: "Ruejai Club",
    JURISTIC_SYSTEM: "Juristic System",
    INSTALLER_WIZARD: "Installer Wizard",
    HA_HOME_OS: "HA.HomeOS",
    LEAD_MANAGEMENT: "Lead Management",
    DELETE_CUSTOMER: "Delete Customer",
    YOU_TELL_US: "You Tell Us",
    SUPPLIER: "Supplier",
    SUPPLIER_MANAGEMENT: "Supplier Management",

    // RJAPP-6382 Fix Bypassing Authorization Schema (Penetration testing 2024)
    BANNER: "Banner",
    PINNED_ARTICLE: "Pinned Article",
    QR_CHECK_IN: "QR Check-in",
    USER_LIST: "User List",
    PROJECT_LIST: "Project List",
    CONTACT_PROJECT: "Contact Project",
    RESIDENT_LIST: "Resident List",
    MESSAGING: "Messaging",
    STAFF_LINE_MANAGEMENT: "Staff Line Management",
    SUBSCRIPTION_COLLECTION: "Subscription Collection",
    SUBSCRIPTION_PACKAGE: "Subscription Package",
    SUBSCRIPTION_SERVICE: "Subscription Service",
    SUBSCRIPTION_SERVICE_CATEGORY: "Subscription Service Category",
    SUBSCRIPTION_SERVICE_PROVIDER: "Subscription Service Provider",
    SUBSCRIPTION_COUPON: "Subscription Coupon",
    SUBSCRIPTION_REQUESTED_PACKAGE: "Subscription Requested Package",
    SUBSCRIPTION_MEMBER: "Subscription Member",
    SUBSCRIPTION_ACCOUNTING_REPORT: "Subscription Accounting Report",
    SUBSCRIPTION_APPOINTMENT: "Subscription Appointment",
    SUBSCRIPTION_PRODUCT_APPOINTMENT: "Subscription Product Appointment",
    SUBSCRIPTION_APPOINTMENT_RATING: "Subscription Appointment Rating",
    SUBSCRIPTION_RECURRING_REPORT: "Subscription Recurring Report",
    SUBSCRIPTION_RECEIPT: "Subscription Receipt",
    RUEJAI_CLUB_PACKAGE_GROUP: "Ruejai Club Package Group",
    HOME_AUTOMATION_WEB: "Home Automation Web",
    HOME_AUTOMATION_APPOINTMENT: "Home Automation Appointment",
    RUEJAI_CLUB_BANNER: "Ruejai Club Banner",
    RUEJAI_CLUB_TIER: "Ruejai Club Tier",
    RUEJAI_CLUB_GROUP_CATEGORY: "Ruejai Club Group Category",
    RUEJAI_CLUB_CATEGORY: "Ruejai Club Category",
    RUEJAI_CLUB_VOUCHER_PACKAGE: "Ruejai Club Voucher Package",
    LEAD_GENERATOR: "Lead Generator",
    LEAD_GENERATOR_CC: "Lead Generator CC",
    MNC_EARN_REPORT: "MNC Earn Report",
    MNC_GIFT_BOX_REPORT: "MNC Gift Box Report",
    MNC_HOME_TRANSFER_REPORT: "MNC Home Transfer Report",
    MNC_WALLET_BALANCE_REPORT: "MNC Wallet Balance Report",
    MNC_MANUAL_TRANSFER: "MNC Manual Transfer",
    EV_PARKING: "EV Parking",
    SAP_FI_REPORT: "SAP FI Report",
    SAP_MM_REPORT: "SAP MM Report",
    SAP_FI_ERROR_REPORT: "SAP FI Error Report",
    SAP_MM_ERROR_REPORT: "SAP MM Error Report",
    SAP_PO_VENDOR_REPORT: "SAP PO Vendor Report",
    SAP_FI_NOT_SENT_REPORT: "SAP FI Not Sent Report",
    CONFERENCE: "Conference",
    REWARD_STORE_REDEEM_REPORT: "Reward Store Redeem Report",
    REWARD_STORE_HOME_DISCOUNT_REPORT: "Reward Store Home Discount Report",
    NONSC_MGMT: "Non-SC Management",
  }
};



// WEBPACK FOOTER //
// ./src/config/enums.js